module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAADam2dgAAAAPUlEQVQYlX2OQQoAMAjD4v7/5w5hih1svQgxWEOSgMBjbJ2Z8E6zkr5iSrOqRGMpzQu1NDbr7ueblfQUADaERA0LWrcamwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ri_ico.png
// module id = JkoT
// module chunks = 1